// extracted by mini-css-extract-plugin
export default {"root":"MainPage_root__kO-os","container":"MainPage_container__VY+BI"};